import type {RuleValidationErrors} from '../types';
import {CustomRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateCustomRule = <T extends CustomRule = CustomRule>(
	rule: T,
): RuleValidationErrors | false => {
	if (rule.elementValue1 === '') {
		return {
			elementValue1: createValidationObject(),
		};
	}
	return false;
};

export default validateCustomRule;
